var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGreenTickIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#51DC8E"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.707 11.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L14 18.586l7.293-7.293a1 1 0 011.414 0z",
    fill: "#1E1E1E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenTickIcon);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTYiIGN5PSIxNiIgcj0iMTYiIGZpbGw9IiM1MURDOEUiLz4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0yMi43MDcxIDExLjI5MjlDMjMuMDk3NiAxMS42ODM0IDIzLjA5NzYgMTIuMzE2NiAyMi43MDcxIDEyLjcwNzFMMTQuNzA3MSAyMC43MDcxQzE0LjMxNjYgMjEuMDk3NiAxMy42ODM0IDIxLjA5NzYgMTMuMjkyOSAyMC43MDcxTDkuMjkyODkgMTYuNzA3MUM4LjkwMjM3IDE2LjMxNjYgOC45MDIzNyAxNS42ODM0IDkuMjkyODkgMTUuMjkyOUM5LjY4MzQyIDE0LjkwMjQgMTAuMzE2NiAxNC45MDI0IDEwLjcwNzEgMTUuMjkyOUwxNCAxOC41ODU4TDIxLjI5MjkgMTEuMjkyOUMyMS42ODM0IDEwLjkwMjQgMjIuMzE2NiAxMC45MDI0IDIyLjcwNzEgMTEuMjkyOVoiIGZpbGw9IiMxRTFFMUUiLz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };